import { createContext, useContext } from 'react'

export type User = {
  username: string
  attributes: {
    email: string
    email_verified: boolean
  }
}

export enum AuthStatus {
  Unauthenticated = 0,
  Authenticated = 1,
  Authenticating = 2,
  Unknown = 3
}

export type AuthState =
  | {
      status: AuthStatus.Authenticated
      user: User
    }
  | {
      status: AuthStatus.Authenticating | AuthStatus.Unauthenticated | AuthStatus.Unknown
      user: null
    }

const AuthContext = createContext({
  user: null as User | null,
  status: AuthStatus.Unauthenticated,
  signOut: async () => {},
  forceSignIn: async () => {},
  signUp: async () => {}
})

export const AuthProvider = AuthContext.Provider

/**
 * Get the current user and their authentication status,
 * as well as methods to sign out, force sign in, and sign up.
 */
export const useAuth = () => {
  return useContext(AuthContext)
}
